// DVC Resort and Points Data
import { Calendar, Home, Palmtree, Castle, Mountain, Waves, TreePine, Sunset, Ship, Star } from 'lucide-react';
// Using points-charts.json as the single source of truth
import newPointsData from './points-charts.json';
import { getAvailableRoomTypesFromNewSchema, getAvailableViewTypesFromNewSchema, getResortCodeFromName } from '../utils/dataTransform.js';
export const DVC_RESORTS = {
  // Walt Disney World Resorts
  'AKV': {
    name: 'Animal Kingdom Villas - Jambo House',
    location: 'Walt Disney World',
    homeResort: 'AKV',
    icon: 'TreePine'
  },
  'AKL': {
    name: 'Animal Kingdom Villas - Kidani Village',
    location: 'Walt Disney World',
    homeResort: 'AKL',
    icon: 'TreePine'
  },
  'BWV': {
    name: 'BoardWalk Villas',
    location: 'Walt Disney World',
    homeResort: 'BWV',
    icon: 'Ferris-wheel'
  },
  'BCV': {
    name: 'Beach Club Villas',
    location: 'Walt Disney World',
    homeResort: 'BCV',
    icon: 'Waves'
  },
  'BLT': {
    name: 'Bay Lake Tower at Contemporary Resort',
    location: 'Walt Disney World',
    homeResort: 'BLT',
    icon: 'Building2'
  },
  'CCV': {
    name: 'Copper Creek Villas & Cabins at Wilderness Lodge',
    location: 'Walt Disney World',
    homeResort: 'CCV',
    icon: 'Mountain'
  },
  'OKW': {
    name: 'Old Key West Resort',
    location: 'Walt Disney World',
    homeResort: 'OKW',
    icon: 'Key'
  },
  'PVB': {
    name: 'Polynesian Villas & Bungalows',
    location: 'Walt Disney World',
    homeResort: 'PVB',
    icon: 'Palmtree'
  },
  'RIV': {
    name: 'Riviera Resort',
    location: 'Walt Disney World',
    homeResort: 'RIV',
    icon: 'Castle'
  },
  'SSR': {
    name: 'Saratoga Springs Resort & Spa',
    location: 'Walt Disney World',
    homeResort: 'SSR',
    icon: 'Droplets'
  },
  'VGF': {
    name: 'Villas at Grand Floridian Resort & Spa',
    location: 'Walt Disney World',
    homeResort: 'VGF',
    icon: 'Crown'
  },
  'VGC': {
    name: 'Villas at Grand Californian Hotel & Spa',
    location: 'Disneyland Resort',
    homeResort: 'VGC',
    icon: 'Crown'
  },
  'VDH': {
    name: 'Villas at Disneyland Hotel',
    location: 'Disneyland Resort',
    homeResort: 'VDH',
    icon: 'Castle'
  },
  // Disney Collection
  'HIL': {
    name: 'Hilton Head Island Resort',
    location: 'Hilton Head Island',
    homeResort: 'HIL',
    icon: 'Waves'
  },
  'VB': {
    name: 'Vero Beach Resort',
    location: 'Vero Beach',
    homeResort: 'VB',
    icon: 'Waves'
  }
};



// Season Calendar (simplified - would need full year data)
export const getSeasonForDate = (date) => {
  const month = date.getMonth() + 1;
  const day = date.getDate();
  
  // Simplified season logic - this would need to be more comprehensive
  if ((month === 12 && day >= 20) || (month === 1 && day <= 2)) {
    return 'HOLIDAY';
  } else if (month >= 6 && month <= 8) {
    return 'DREAM';
  } else if (month >= 3 && month <= 5) {
    return 'MAGIC';
  } else if (month >= 9 && month <= 11) {
    return 'CHOICE';
  } else {
    return 'ADVENTURE';
  }
};

// Use Year months (DVC contracts have different use year start dates)
export const USE_YEAR_MONTHS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 6, label: 'June' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 12, label: 'December' }
];


// Get available room types for a specific resort directly from points-charts.json
export const getAvailableRoomTypes = (resort) => {
  return getAvailableRoomTypesFromNewSchema(newPointsData, resort, 2025);
};

// Get available view types for a specific resort and room type directly from points-charts.json
export const getAvailableViewTypes = (resortCode, roomType) => {
  if (!resortCode || !roomType) return [];
  
  return getAvailableViewTypesFromNewSchema(newPointsData, resortCode, roomType, 2025);
};

// Get available resorts directly from points-charts.json
export const getAvailableResorts = () => {
  if (!newPointsData || !Array.isArray(newPointsData)) {
    return {};
  }
  
  const resorts = {};
  const uniqueResorts = [...new Set(newPointsData.map(r => r.ResortName))];
  
  uniqueResorts.forEach(resortName => {
    const code = getResortCodeFromName(resortName);
    resorts[code] = {
      name: resortName.replace('DVC - ', ''), // Clean up the name
      location: 'Disney Vacation Club',
      homeResort: code,
      icon: 'Home' // Default icon
    };
  });
  
  return resorts;
};

// View premium is now handled directly by the points-charts.json data
// Different view types have different point values in the JSON
export const getViewPremium = (resortCode, roomTypeCode, viewType) => {
  // This function is deprecated - points are now calculated directly from JSON data
  // which already includes view-specific pricing
  return 0;
};

// This function is deprecated - use calculateStayPoints from dvcLogic.js instead
// Keeping for backward compatibility but it now returns 0
export const getPointsForStay = (resort, roomType, checkIn, checkOut, viewType = 'STANDARD') => {
  console.warn('getPointsForStay is deprecated. Use calculateStayPoints from dvcLogic.js instead.');
  return 0;
};
